<template>
  <div class="privacy-policy">
    <header>
      <h1>卡普喔隐私政策</h1>
      <p>最近更新日期：【2026】年【01】月【19】日。</p>
    </header>
    <section>
      <p>
        重庆盛纳科技有限公司是卡普喔APP的运营者（以下称“卡普喔”或“我们”），主要通过以装扮小屋的形式鼓励用户坚持记录，可一人或两人绑定使用。卡普喔非常重视用户的隐私和个人信息保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。我们希望通过《卡普喔隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。同时，我们承诺将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
      </p>
      <p>
        <b class="red">我们非常重视对未成年人个人信息的保护，但我们无法保证时刻都能准确、真实地了解到您的年龄。若您是18周岁以下的未成年人，在使用卡普喔的服务前，应事先取得家长或法定监护人的书面同意，并在家长或法定监护人指导下使用卡普喔服务。</b>
      </p>
      <p>
        如您使用或继续使用卡普喔的服务，表示您同意卡普喔按照本《隐私政策》收集、使用、储存、分享和保护您的信息。
      </p>
      <p>
        如果您对我们处理您的个人数据有任何疑问或顾虑，请通过联系邮箱kapuou@163.com或本政策列明的其他联系方式与我们联系。
      </p>
    </section>
    <section>
      <h2>（一）我们如何收集和使用您的个人信息</h2>
      <p>
        当您使用我们的产品和服务时,我们只会收集您选择的服务所必需的、特定的、明确及合法目的的信息，并且不会以与这些目的不相符的方式进一步处理相关信息。根据您选择的服务，我们可能收集以下信息中的一种或多种：
      </p>
      <ul>
        <li>
          <p>
            1、您在使用我们服务时主动提供或上传的信息，我们会根据您选择的服务收集相应服务必要的部分个人信息。例如：
          </p>

          <p>
            （1）若您创建卡普喔账号，您可以使用第三方账号（微信、QQ、苹果）登录卡普喔，此时您将会提供第三方账号相关昵称、头像、性别信息；您也可以使用手机号进行注册，我们将通过发送短信验证码的方式验证您的身份是否有效。
          </p>

          <p>（2）若您上传、更换您的头像，我们会使用您的图片、存储权限。</p>

          <p>
            （3）若您使用卡普喔的记录功能上传图片时，我们需要使用您的相册、存储权限。若保存图片，我们将获取您的存储权限。
          </p>

          <p>（4）若您使用照相机功能，我们会使用您的摄像头、存储权限。</p>

          <p>
            （5）若双方需要输入密令实现账号绑定、解绑后的恢复以及恢复聊天记录，我们需要获取您的存储权限。
          </p>

          <p>
            （6）若您使用距离查看功能或实时共享位置，我们会收集您的地理位置信息。您同意开启设备定位服务后，我们会通过GPS或WiFi等方式持续收集您的地理位置信息，将用于为您记录位置信息。您可以通过关闭手机定位服务，停止我们对您的地理位置信息进行收集，同时我们也将无法记录您的位置并展示相关足迹信息。
          </p>
          <p>
            （7）若您使用距离查看或实时共享位置，我们将获取您的设备电量信息和充电状态，如果你不想让对方看见该信息，可直接在定位设置中关闭定位。
          </p>

          <p>
            （8）若您使用蜜语功能进行语音聊天，我们将会收集您的麦克风权限。若您是安卓用户，为便于您及时获取与您绑定的用户发送的蜜语消息，卡普喔会自启动蜜语相关进程。
          </p>
          <p>（9）若您需要发送图片，我们将会收集您的摄像头、相册权限。</p>
          <p>
            <b class="red">（10）若您使用卡普喔的付费服务，若您进行交易时，支付功能由与我们合作的第三方支付机构向您提供。第三方支付机构可能需要收集您的姓名、银行卡类型及卡号、有效期及手机号码。银行卡号、有效期及手机号码是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。在您成功付款后，我们仅会从该第三方付款服务提供商处获取您已完成付款的结果验证信息，进而向您提供相应产品。若您希望了解第三方服务提供商收集个人信息的具体规则，请参阅您选择的第三方付款服务提供商的隐私政策。</b>
          </p>
          <p>
            （11）为向您展示账号的交易信息并保障交易安全，我们会收集您在使用我们服务过程中产生的信息（您所购买的商品或服务信息、具体订单号、订单创建时间、交易金额）用于向您展示及便于您对订单进行管理。
          </p>
          <p>
            （12）为便于您接收纪念日提醒通知，我们将会获取您的通知、日历写入权限。
          </p>
          <p>（13）若您使用“更换音乐背景”功能时，我们会收集您的存储权限。</p>
          <p>
            （14）在您使用聊天时，为了更好接收到对方的消息，应用会在后台情况下将获取你的用户信息和设备信息。
          </p>
          <p>
            （15）在绑定页为了更好检测您是否已匹配，应用会在后台情况下获取您的用户信息和绑定状态。
          </p>
          <p>
            （16）为保证良好的用户体验，向您提供众多免费、优质服务，尽量减少与您无关的广告给您造成的侵扰，我们会基于收集的信息，对您的偏好、浏览记录、使用习惯做特征分析和用户画像，并通过广告服务商/供应商系统向您展现或推荐个性化（而非普遍推送）广告，以便能更好地满足您的需求。请您知悉，这些信息难以或无法与您的真实身份相关联，我们收集这些信息只是为了帮助我们分析、衡量广告和相关服务的有效性。
          </p>
          <p>
            <b
              >如果您不希望被推荐个性化广告，可点击主页右上角头像进入【个人中心】->点击个人中心右上角的【设置】按钮->【个性化广告推荐】->关闭个性化广告推荐。关闭后，您所看到的广告数量可能不会减少，但广告相关度将会降低。</b
            >
          </p>
          <p>
            <b class="red">（17）若您通过我们的客服或参加我们举办的活动时，您可能会提供姓名、电话、通讯地址用于活动联络。</b>
          </p>
          <p>
            （18）为更好的向您提供服务，我们可能不时增加或调整部分特殊服务功能，若您选择使用某项特殊服务功能的，您可能会自主向我们提供使用该服务功能所需的个人信息。
          </p>
          <p>
            （19）同意隐私政策之后，友盟第三方SDK会在后台情况下获取您的用户信息和设备信息，用于数据的统计。
          </p>

          <p>
            上述部分服务功能可能需要您提供特定的个人信息或者开启特定的权限来实现特定服务，若您选择不提供该类信息或拒绝开启特定权限，则可能无法正常使用该部分服务功能。
          </p>

          <p>
            请注意，如您自主向我们披露您的健康、隐私生活或个人生物特征信息相关敏感信息的，我们将严格按照本政策的规定保护您的信息，但您应当谨慎向第三方产品或服务提供方提供您的个人敏感信息。
          </p>
        </li>

        <li>
          <p>2、我们在您使用服务时获取的信息</p>

          <p>
            在您使用卡普喔网络服务、访问卡普喔平台网页或当卡普喔处于后台状态时，我们会接收并记录您的浏览器、设备上的信息或<b class="red">运行中的进程信息</b>，用于鉴别用户身份、记录系统故障和分析系统故障时产生的原因、用户行为分析、广告投放监测、开展内部审计、数据分析和研究等，以促进改善、优化我们的产品、服务。
          </p>

          <p>
            （1）独特的识别码和设备信息：您的设备产商、设备型号、设备语言、设备名称、应用列表信息、硬件序列号、操作系统和应用程序版本及类型、语言设置、分辨率、IP地址、GPS位置、系统平台、系统版本、应用包名及版本、应用前后置时间、独立设备标识（Android
            ID、iOS广告标识符（IDFA）、网卡（MAC）地址、国际移动设备识别码（IMEI）、
            匿名设备标识符(
            OAID)、国际移动用户识别码（IMSI）基站信息）、传感器信息、蓝牙信息、WIFI状态信息、CPU信息、内存信息、设备信息、电池使用情况、网络接入方式及类型、类型、状态、网络质量数据、操作日志信息（包括浏览记录、检索记录、点击查看记录、交易记录及IP地址、电信运营商、访问日期和时间）；
          </p>

          <p>
            （2）有关您使用卡普喔服务的订单数据，查询已支付、待支付的订单记录；
          </p>

          <p>
            （3）有关您使用卡普喔服务的行为使用数据，点击的网页、访问的网站和内容区域、广告数据、活动日期和时间。
          </p>
        </li>

        <li>
          <p>
            3、收集设备MAC地址、软件安装列表的目的方式范围<b>（更多详情请见附件一的第三方SDK说明表）</b>
          </p>
          <p>
            (1)
            为改进及优化我们的服务体验，我们接入的第三方友盟SDK将会收集您的MAC地址信息，用于数据统计和服务优化
          </p>
          <p>(2) 穿山甲广告SDK将会收集您的MAC地址信息，用于广告投放</p>
          <p>(3) 广点通广告SDK将会收集您的MAC地址信息，用于广告投放</p>
          <p>(4) 小满广告SDK将会收集您的MAC地址信息，用于广告投放</p>
          <p>
            (5)
            用于实现安卓内支付宝支付服务，帮助用户完成付款、提供安全认证服务，支付宝SDK将会收集您的MAC地址信息
          </p>
          <p>
            (6) 用于实现安卓内微信支付服务，微信支付SDK将会收集您的MAC地址信息
          </p>
          <p>(7) 友盟Ushare SDK将会收集您的MAC地址信息，用于一键分享</p>
          <p>
            (8) 在分享给好友，分享心心码等情景时，我们将会收集您的软件安装列表
          </p>
          <p>
            (9)
            在部分广告回调时，我们将会收集您的软件安装列表，关闭个性化推荐后不再收集
          </p>
          <p>(10) 应用下载类广告会获取安装列表判断是否有安装过广告应用</p>
        </li>

        <li>
          <p>
            4、您应当知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
          </p>

          <p>（1）与国家安全、国防安全有关的；</p>

          <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>

          <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>

          <p>
            （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </p>

          <p>（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</p>

          <p>
            （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
          </p>

          <p>（7）根据您的要求签订合同所必需的；</p>

          <p>
            （8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
          </p>

          <p>（9）为合法的新闻报道所必需的；</p>

          <p>
            （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
          </p>

          <p>（11）法律法规规定的其他情形。</p>
        </li>
      </ul>
      <h2>（二） 我们使用您个人信息的规则</h2>
      <ul>
        <li>
          <p>
            1、基于为您提供服务的目的使用：我们会在您注册卡普喔账号、自主选择卡普喔服务或其他本隐私政策的约定情形下，为实现我们的产品或服务功能收集您的个人信息进行使用。在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们可能会对用户数据库进行分析并予以商业化的利用。
          </p>
        </li>
        <li>
          <p>
            2、基于客户调查或就订单与您联系的目的使用：我们可能会收集您在参与产品、服务调查时主动向我们提供的信息，以及您与我们的关联方、合作伙伴之间互动时提供的相关信息，以便于您追踪订单情况、发起用户投诉以及我们优化客户服务的质量与流程。
          </p>
        </li>
        <li>
          <p>
            3、基于网络安全保障、APP功能的目的使用：为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息等来综合判断您的账号及交易风险，包括验证身份，预防、发现、调查可能存在的欺诈、网络病毒、网络攻击等安全风险以及违反我们或关联方协议、政策或规则等行为，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接(“URL”)。
          </p>
        </li>
        <li>
          <p>
            4、基于统计分析和改进运营的目的使用：我们可能将业务中收集的个人信息用于统计分析和改进运营，例如通过您所在的位置、偏好等进行统计分析，从而改进我们的产品、服务或营销计划；又如为改进我们系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告等。并可能会与第三方共享部分统计信息（不包含您的任何身份识别信息）以展示我们的产品或服务的整体使用趋势。当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏以保护您的信息安全。
          </p>
        </li>
        <li>
          <p>
            5、基于获得合作伙伴和第三方服务提供商的服务的目的使用：我们与向卡普喔提供服务的第三方共享个人数据，例如，分析、网站管理、广告、数据扩充机构、信息技术和相关基础设施提供、客户服务、审计和其他类似服务。卡普喔与第三方服务提供商共享个人数据时，我们要求他们仅将您的个人数据用于向我们提供服务，并遵循与隐私保护政策一致个人信息保护要求。
          </p>
        </li>
        <li>
          <p>
            6、其他用途：当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。
          </p>
        </li>
      </ul>

      <p>
        请您注意，您在使用我们的产品或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品或服务期间持续授权我们使用。在您可通过本政策第（三）条列明的路径注销卡普喔账户及或取消隐私信息授权，以删除您的个人信息。
      </p>

      <h2>（三） 您如何访问和控制自己的个人信息</h2>
      <ul>
        <li>
          <p>
            1、我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，我们可能会要求您进行身份验证，以保障您的账户安全。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。
          </p>
        </li>

        <li>
          <p>2、访问信息</p>

          <p>
            （1）若您查看您的头像、昵称，您可以通过点击首页右上角“头像-个人中心”进行操作。
          </p>
          <p>
            （2）若您查看与您绑定的账号的头像、昵称，您可通过点击首页右上角“头像-个人中心”进行操作。
          </p>
          <p>
            （3）若您查看您的会员状态的，您可以通过点击首页右上角“头像—个人中心”进行操作。
          </p>
          <p>
            （4）若您查看您的小心心，您可通过点击首页右上角“头像-个人中心”进行操作。
          </p>
          <p>
            （5）若您查看您自己的或者和您绑定账号共同的记录信息，您可以通过点击首页底部的“相册”、“点滴”、“纪念日”、“愿望”进行操作。
          </p>

          <p>
            （6）若您查看您的当前位置、绑定账号的当前位置，您可通过点击首页底部“妙妙屋-百宝箱-在哪儿”进行操作。
          </p>
          <p>
            （7）若您查看您和绑定账号的聊天记录信息，您可以通过“首页-蜜语”进行操作。
          </p>
          <p>
            （8）若您查看他人的来信或查看自己写的信，您可以通过点击首页底部“妙妙屋-百宝箱-书信”进行操作。
          </p>
        </li>
        <li>
          <p>3、更改个人信息</p>

          <p>
            （1）若您更改您的昵称、头像，您可以通过点击首页右上角“头像—个人中心-账号管理”进行操作。
          </p>

          <p>
            （2）若您想与好友一起使用，可以点击首页右上方的“一拍即合”输入对方心心码进行绑定。
          </p>

          <p>
            （3）若您绑定后想解除绑定，可以点击首页右上角“头像-个人中心-一按即散”进行操作。
          </p>
          <p>
            （4）若解绑后与同一账号再次绑定成功后想恢复过往数据，可以点击首页右上角“头像-个人中心-后悔药”进行恢复操作。
          </p>
          <p>
            （5）若您需要开通VIP权益，您可以通过点击首页右上角“头像-个人中心-立即升级”进行操作。
          </p>
        </li>

        <li>
          <p>
            4、删除信息、撤回授权
            若您需要删除个人信息，您可以通过手机设置-应用管理-卡普喔-存储-删除数据/清空缓存清除卡普喔应用数据信息，也可以通过“点击头像—个人中心-账号管理—注销账号”清除您的信息。
            若您需要撤回授权，您可以通过“手机设置-隐私-权限管理”更改权限设置，撤回您的授权。
          </p>
        </li>

        <li>
          <p>
            5、注销账户
            您可以通过“点击头像—个人中心-账号管理—注销账号”进行操作，当您注销账号后，我们将按照《中华人民共和国网络安全法》等法律法规的规定留存你的相关信息；超出法定保存期限后，我们将删除或匿名化处理你的个人信息。
          </p>
        </li>

        <li>
          <p>
            6、投诉反馈
            若您有任何意见或建议的，您可以通过“个人中心-关于我们”里展示的联系方式与卡普喔客服取得联系。
          </p>
        </li>

        <li>
          <p>
            7、如您不希望收到卡普喔页面上的消息通知，可以在首次安装卡普喔时拒绝接收消息通知，或者在移动端操作系统中的“通知”中心关掉对应的通知功能。
          </p>
          <p>
            请您理解，因手机设备不同，上述删除/注销数据、修改权限的途径会有所区别，如您有任何疑问的可联系本平台。当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权而开展的个人信息处理。
          </p>
        </li>
      </ul>
      <h2>（四） 我们会如何共享、转让、公开披露您的个人信息</h2>
      <ul>
        <li>
          <p>
            1、共享：我们遵照法律法规的规定，对信息的分享进行严格的限制。原则上我们不会与卡普喔以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：
          </p>
          <p>(1)事先获得您明确的同意或授权；</p>
          <p>
            (2)实现本《隐私政策》第（一）条“我们如何收集和使用信息”部分所述目的；
          </p>
          <p>
            (3)履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利；
          </p>
          <p>
            (4)维护和改善我们的服务。我们可能向我们的服务提供商等合作伙伴（例如：代表我们发出电子邮件的通讯服务提供商等）分享您的信息，以帮助我们为您提供更有针对性、更完善的服务；
          </p>
          <p>
            (5)根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
          </p>
          <p>
            (6)在法律法规允许的范围内，为维护卡普喔、卡普喔的关联方或合作伙伴、您或其他卡普喔用户或社会公众利益、财产或安全免遭损害而有必要提供；
          </p>
          <p>
            (7)向委托我们进行推广的合作伙伴等第三方共享，目的是为了使该等委托方了解推广的覆盖面和有效性。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。
          </p>
          <p>
            (8)只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；
          </p>
          <p>(9)应您需求为您处理您与他人的纠纷或争议；</p>
          <p>(10)应您的监护人合法要求而提供您的信息；</p>
          <p>
            (11)根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；基于学术研究而使用；
          </p>
          <p>(12)基于符合法律法规的社会公共利益而使用；</p>
          <p>
            (13)仅为实现外部处理目的，经加密、匿名化处理等手段处理后，向第三方合作伙伴分享。
          </p>
          <p>
            为了您的信息安全，我们已与第三方SDK/API服务商签署严格数据安全保密协议，这些公司会严格遵守我们的数据隐私和安全要求。除非得到您的授权，我们不会与其共享您的个人身份信息。为向用户提供更多服务、保证服务稳定性和质量或升级相关功能时，我们可能会调整我们接入的第三方SDK，届时我们会及时在本页面向您说明收集用户信息的第三方SDK的最新情况。关于第三方的身份、SDK的类型、收集的个人信息的类型、收集目的以及第三方的隐私政策链接等，请详见本政策附件一第三方SDK的说明。
          </p>
        </li>
        <li>
          <p>2、信息使用规则</p>
          <p>
            （1）我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。
          </p>
          <p>
            （2）我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息。对我们与之共享信息的公司、组织和个人，我们要求他们按照我们的说明、本《隐私政策》以及其他任何相关的保密和安全措施来处理信息。
          </p>
          <p>
            （3）请您知悉，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并尽量对共享内容中的个人信息进行去标识化处理。
          </p>
        </li>

        <li>
          <p>
            3、转让：我们不会将您的个人信息出售给任何公司、组织和个人，除非（a）获得您的明确同意后，我们会向其他方转让您的个人信息；(b)在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
          </p>
        </li>

        <li>
          <p>
            4、公开披露：我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息:
          </p>
          <p>（a）获得您的明确同意；</p>
          <p>（b）基于法律法规、法律程序、诉讼或政府主管部门强制性要求。</p>
          <p>（c）遵守相关政府机关或其他法定授权组织的要求；</p>
          <p>（d）我们有理由确信需要遵守法律法规等有关规定；</p>
          <p>（e）为执行相关服务协议或本政策；</p>
          <p>
            （f）我们认为为遵守适用的法律法规、维护社会公共利益、或保护我们或我们的集团公司、我们的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的。
          </p>
        </li>
      </ul>
      <h2>（五）我们如何储存、保护、管理您的信息</h2>
      <ul>
        <li>
          <p>
            1、信息存储地点：我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。
          </p>
        </li>
        <li>
          <p>
            2、信息存储期限：我们将会按照《网络安全法》、《电子商务法》规定的期限仅会在达到本政策所述目的所必需的时限内保存您的个人信息，最低期限不少于6个月，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。若超出法定保存期限后，我们会将您的个人信息删除或做匿名化处理。
          </p>
        </li>
        <li>
          <p>3、信息保护管理</p>

          <p>
            （1）我们承诺我们将使信息安全保护达到合理的安全水平。为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来防止您的信息被泄露、毁损或者丢失，同时我们通过建立相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则。
          </p>

          <p>
            （2）我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
          </p>

          <p>
            （3）在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、软件内通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
          </p>

          <p>
            （4）如我们停止运营，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。涉及未成年人个人信息的，我们会并将停止运营的通知及时告知未成年人的监护人。
          </p>
        </li>
      </ul>

      <h2>（六）我们会如何使用COOKIES及同类技术</h2>
      <p>
        您使用我们的服务时，我们或我们的第三方合作伙伴，可能通过放置安全的Cookie及同类技术收集您的信息。我们会严格要求第三方合作伙伴遵守本政策的相关规定。Cookie对提升用户的网络使用体验十分重要，我们使用Cookie一般出于以下目的：
      </p>
      <ul>
        <li>
          <p>
            1、身份验证：Cookie可在您接入我们的服务时通知我们，以使我们可验证您的身份信息，以确保您的账号安全。例如，Cookie技术可在您登录卡普喔服务时通知我们，因此，我们能够在您访问所有卡普喔服务时，识别是否您本人安全登录，向您显示与您相关的信息。
          </p>
        </li>
        <li>
          <p>
            2、偏好设置：Cookie可帮助我们按照您所希望的服务样式、外观的设置为您提供服务。
            例如，
            Cookie技术可记录您是否已经阅读过一些提示性的展现，防止重复提示对您造成骚扰；一些阅读展现(如字体大小等)方面您本人偏好的设定，我们也会存放于Cookie中，在您访问时自动为您调整到您上次设定的值。
          </p>
        </li>
        <li>
          <p>
            3、保障安全：Cookie可帮助我们保障数据和服务的安全性，排查针对我们的产品和服务的作弊、黑客、欺诈行为。例如，Cookie可以存放票据信息，能够由服务器验证是否是您自主在本站点的正常登录，通过票据中的加密信息，阻止多种类型的攻击，防止跨站信息窃取访问，防止身份冒充访问。
          </p>
        </li>
        <li>
          <p>
            4、功能与服务：Cookie可帮助我们为用户提供更好的产品和服务。例如，Cookie可以在您进行登录时，通过存储的信息，帮您填入您最后一次登入的账户名称，提高您的操作效率。
          </p>
        </li>
        <li>
          <p>
            5、提高效率：Cookie可以避免不必要的服务器负载，提高服务效率，节省资源、能源。例如，Cookie可帮助我们优化在服务器之间路由流量，并且了解不同用户加载我们服务时的速度，有时，我们或会利用Cookie让您正在使用时加载及响应得更快。
          </p>
        </li>
        <li>
          <p>
            6、分析与研究：我们使用这些Cookie来了解、改善我们的产品和服务，为新产品或功能的研发提供参考数据。例如，我们会使用Cookie来了解您使用我们服务的方式，以求改善用户体验。例如您在接入我们服务时，在各个步骤所耗费的时间，我们会收集此信息用以分析研究能够进一步优化和改善的方面。
          </p>
        </li>
        <li>
          <p>
            7、广告优化：我们向用户提供众多免费、优质的服务，而广告收入是支持我们运营的重要收入来源，如果没有广告收入，我们将难以向您提供更多免费、优质的服务。为了保证良好的用户体验，尽可能地减少与您无关的广告对您造成的侵扰，我们会根据您使用我们服务的情况，尽可能向您展示您可能更感兴趣、更实用的广告，我们也可使用Cookie来知道曾在卡普喔平台看见广告的人，之后是否浏览该广告商的网站。同样地，我们的合作伙伴可能会运用Cookie来确定我们是否已显示广告、了解广告的表现，或向我们提供他们与您之间的互动信息。在向您展示广告的过程中，我们将努力确保数据的安全性。
          </p>
        </li>
        <li>
          <p>
            8、如何禁用：如您不希望个人信息保存在
            Cookie中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用
            Cookie功能后，可能影响您访问卡普喔或不能充分取得卡普喔提供的服务。卡普喔不会将Cookie
            用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止
            Cookie 的功能。
          </p>
        </li>
      </ul>
      <h2>（七）我们服务中的第三方服务</h2>
      <ul>
        <li>
          <p>
            请您注意，您的交易相对方、您访问的第三方网站经营者、通过我们接入的第三方服务可能有自己的隐私权保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或标签不受我们的控制，且它们的使用不受本政策的约束。我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，我们不对第三方如何使用他们向您搜集的个人信息负责，也不能控制其使用，我们强烈建议您仔细阅读第三方的隐私政策，就像阅读我们的隐私政策一样。如果您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。
          </p>
        </li>
      </ul>

      <h2>（八）未成年人的保护</h2>
      <p>
        <b class="red">1、卡普喔非常重视对未成年人个人信息的保护。我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导。</b>
      </p>
      <p>
        <b class="red">2、根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用本服务前，应事先取得您的家长或法定监护人的同意。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策第十一条中的联系方式与我们联系。</b>
      </p>
      <h2>（九）本政策的适用范围</h2>
      <ul>
        <li>
          <p>
            我们所有的服务均适用本政策。某些服务有其特定的隐私指引/声明，该特定隐私指引/声明更具体地说明我们在该服务中如何处理您的信息。如本政策与特定服务的隐私指引/声明有不一致之处，请以该特定隐私指引声明为准。
          </p>
        </li>
        <li>
          <p>
            请您注意，本政策不适用由其他公司或个人提供的服务。例如，您通过使用卡普喔服务接触到的第三方提供的服务。您使用该等第三方服务须受其隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。
          </p>
        </li>
      </ul>

      <h2>（十）本政策的修改</h2>
      <p>
        我们可能适时修订本政策内容。如该等变更属于可能会导致您在本政策项下权利受到影响的重大变更，我们将在变更生效前，通过在页面显著位置提示、或向您发送电子邮件等合适的能触达您的方式通知您。我们会在本页面上发布对本隐私政策所做的任何变更。
      </p>

      <p>
        若您不同意该等变更可以停止使用卡普喔平台产品和服务，若您继续使用我们的产品或服务，即表示您同意受修订后的本隐私政策的约束，更新后的隐私政策将于我们发布或通知（如有）您之日起生效。
      </p>

      <h2>（十一）如何联系我们</h2>
      <p>
        当您有任何疑问、意见或建议时，可以发送电子邮件至kapuou@163.com与我们联系。
      </p>

      <p>我们将尽快审核所涉问题，并在验证您的用户身份后的十五天内予以回复。</p>

      <h2>附件一：关于第三方SDK的说明</h2>
      <p>
        为了适配在不同手机设备上使用卡普喔以及第三方平台服务，实现您的手机设备身份认证、手机设备安全、接收消息通知、登录第三方平台账号、通过第三方平台分享信息以及支付安全，卡普喔接入了第三方SDK。卡普喔所接入的部分第三方SDK会调用您的设备部分权限、获取您的相关信息，以便您在不同的手机设备或第三方平台上正常使用相应功能，我们将这些具有个人信息收集功能的第三方SDK的名称、所提供的功能/服务、隐私政策链接、申请调用的权限及收集个人信息类型，按照实现功能/服务的类别划分列明如下。
      </p>
    </section>
    <section>
      <div>
        <p>
          请注意，第三方 SDK
          可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，具体请以其公示的官方说明为准。
        </p>
        <table border="1" class="tab">
          <thead>
            <tr>
              <th>SDK 名称</th>
              <th>公司名称</th>
              <th>收集目的</th>
              <th>收集方式</th>
              <th>收集范围</th>
              <th>隐私政策</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ele, index) in info">
              <td>{{ ele.name }}</td>
              <td>{{ ele.company }}</td>
              <td>{{ ele.goal }}</td>
              <td>{{ ele.type }}</td>
              <td>{{ ele.range }}</td>
              <td class="link">
                <a :href="ele.link">{{ ele.link }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      info: [
        {
          name: "微信开放平台 SDK",
          company:"腾讯科技（深圳）有限公司",
          goal: "支持微信授权登录、微信分享、微信支付",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（IMEI、IDFA、Android ID、MAC、OAID），网络访问获取Wi-Fi，写入外部存储",
          link: "https://www.tencent.com/zh-cn/privacy-policy.html",
        },
        {
          name: "腾讯bugly SDK",
          company:"腾讯科技（深圳）有限公司",
          goal: "排查崩溃问题,帮助APP提升稳定性",
          type: "调用系统相关接口自动采集",
          range:
            "获取运行中的进程，应用信息：应用标识符、Android ID、设备序列号build_serial、IMEI、IDFA",
          link: "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56",
        },
        {
          name: "QQ 登录 SDK",
          company:"腾讯科技（深圳）有限公司",
          goal: "支持QQ授权登录、QQ分享",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（IMEI、IDFA、Android ID、MAC、OAID），网络访问获取Wi-Fi，写入外部存储",
          link: "https://wiki.connect.qq.com/qq互联sdk隐私保护声明",
        },
        {
          name: "Alipay（支付宝） SDK",
          company:"支付宝（中国）网络科技有限公司",
          goal: "支持使用支付宝支付",
          type: "调用系统相关接口自动采集",
          range:
            "常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、Android ID），网络信息、地理位置信息、应用列表信息",
          link: "https://render.alipay.com/p/c/k2cx0tg8",
        },
        {
          name: "穿山甲(com.bytedance.embedapplog)",
          company:"北京巨量引擎网络技术有限公司",
          goal: "广告投放",
          type: "调用系统相关接口自动采集",
          range:
            "IP地址、设备信息、屏幕参数、设备唯一识别码、设备商机型、操作系统、Mac设备地址、运营商信息、设备类型、设备序列号、地理位置信息、设备应用安装列表信息",
          link: "https://ad.oceanengine.com/union/media/privacy",
        },
        {
          name: "优量汇 SDK",
          company:"腾讯科技（深圳）有限公司",
          goal: "广告投放",
          type: "调用系统相关接口自动采集",
          range:
            "网络访问，设备标识信息【MAC地址信息、IP地址、imei、imsi或oaid、Android Id 、CPU ID 序列号、OpenUUId (iOS)】、地理位置信息，网络访问，获取WiFi状态、设备应用安装列表信息;{com.qq.e.comm.plugin.apkmanager.e=[android.intent.action.PACKAGE_ADDED, android.intent.action.PACKAGE_REMOVED]}接收用户手机安装、卸载应用通知(使用目的：广点通sdk自带的，用于确定是否能打开广告)",
          link: "https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983",
        },
        {
          name: "小满广告 SDK",
          company:"杭州小满信息科技有限公司",
          goal: "广告投放",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识信息（国际移动设备识别码（IMEI）、网络设备硬件地址（MAC））、粗略地理位置信息、网络信息（网络接入方式及类型）、设备应用安装列表信息",
          link: "https://web.hixiaoman.com/app-h5/1.0.0/privacy.html",
        },
        {
          name: "BeiZi SDK",
          company:"上海倍孜网络技术有限公司",
          goal: "广告投放",
          type: "调用系统相关接口自动采集",
          range:
            "[Android和iOS公共信息]设备品牌、设备型号、设备时区、设备语言、系统版本、开发者应用名、应用版本号、应用包名、网络类型、UserAgent信息、网络状态、崩溃信息、性能数据、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、USB调试模式、运营商、cpu、应用的进程名称、应用的进程信息、运行状态、磁盘空间、物理内存[Android独有信息]设备ID（OAID、GAID）（IMEI 用户授权才收集）[iOS独有信息]设备ID（IDFA 用户授权才收集）、IDFV",
          link: "http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy",
        },
        {
          name: "友盟+(com.umeng.commonsdk)",
          company:"友盟同欣（北京）科技有限公司",
          goal: "进行APP运营统计与分析、基础反作弊服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID/SN）、位置信息、网络信息",
          link: "https://www.umeng.com/page/policy",
        },
        {
          name: "友盟Ushare",
          company:"友盟同欣（北京）科技有限公司",
          goal: "分享服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)以及需要分享的社交账号公开信息、设备应用安装列表信息、地理位置信息",
          link: "https://www.umeng.com/page/policy",
        },
        {
          name: "百度联盟",
          company:"北京百度网讯科技有限公司",
          goal: "广告投放",
          type: "调用系统相关接口自动采集",
          range: "基于用户授权获取：设备及应用信息、移动网络信息、位置信息",
          link: "https://union.baidu.com/bqt/#/policies",
        },
        {
          name: "Hyphenate-chat SDK",
          company:"北京易掌云峰科技有限公司",
          goal: "实时聊天、离线消息存储",
          type: "调用系统相关接口自动采集",
          range:
            "设备类型、设备型号、操作系统信息、IP地址、信号强度信息、网络类型、收发端用户ID、频道信息、使用时长、频道内设置姓名、日志、聊天信息：为实现通讯业务功能收集、传输、储存您在使用服务过程中产生的文字通讯信息及音频信息，这些信息可能包括您或者/及与您进行互动的个人向我们提供的您的个人信息（包括您发送的文字、图片、音频、您的图像、声音、肖像以及您交流的内容）",
          link: "https://www.easemob.com/protocol",
        },
        {
          name: "io.agora(声网) SDK",
          company:"上海兆言网络科技有限公司",
          goal: "语音通信",
          type: "调用系统相关接口自动采集",
          range:
            "实时流数据：音视频数据，声网不会存储该类数据；云端录制：声网会在用户会话结束后立即删除该类数据。如果录制数据推送失败，则该类数据至多被声网保留 7 天；实时消息：在实时消息服务场景下收集，其存储时间取决于开发者购买的保留服务时间，到期即删；服务/运营相关数据：服务日志、网络日志、性能数据、功能数据，声网会每 30 天删除一次该类数据；开发者注册数据：姓名、邮箱、手机号码，用于为开发者提供基本产品服务。声网会根据开发者要求对上述注册数据进行删除或匿名化处理，如当开发者注销账号时",
          link: "https://docs.agora.io/cn/Agora%20Platform/privacy_whitepaper?platform=All%20Platforms",
        },
        {
          name: "高德地图 SDK",
          company:"高德软件有限公司",
          goal: "查看双方实时位置、距离、足迹",
          type: "调用系统相关接口自动采集",
          range:
            "各类产品/服务所获取的“位置信息”，包括GNSS信息、IP地址、WLAN热点、基站信息、蓝牙设备以及其他能够用于定位的传感器信息；以下各类产品/服务所获取的“设备信息”，包括终端设备唯一标识符（包含IDFV、OAID、IMEI、MEID、IMSI）、mac地址、操作系统版本、设备品牌及型号、设备配置、运营商类型、应用信息（应用名、应用版本号）",
          link: "https://lbs.amap.com/pages/privacy/",
        },
         {
          name: "巨量引擎转化 SDK",
          company: "北京巨量引擎网络技术有限公司",
          goal: "保障软件与服务的安全运行以及优化产品体验，广告监测归因、广告投放统计分析、反作弊，减少App崩溃、提供稳定可靠的服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备品牌、型号、操作系统、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、浏览器的类型和版本号、操作、使用、服务日志，设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、MAC、OAID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）、地理位置信息，网络访问，获取WiFi状态、设备应用安装列表信息，运营商信息、设备时区、sim卡信息 ",
          link: "https://bytedance.larkoffice.com/docx/PfdrdczIHo0wjex3Qwdce5wYnzh",
        },
        {
          name: "小米推送 SDK",
          company: "北京小米移动软件有限公司",
          goal: "消息推送",
          type: "调用系统相关接口自动采集",
          range:
            "设备相关信息如设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型、WiFi状态。其中当前网络类型、SIM卡运营商名称仅在设备本地读取，不会上传至小米服务器；如您接入的是iOS版，我们还会收集设备相关信息如设备型号、操作系统版本、小米推送SDK版本",
          link: "https://dev.mi.com/distribute/doc/details?pId=1819",
        },
        {
          name: "OPPO推送 SDK",
          company: "广东欢太科技有限公司",
          goal: "消息推送",
          type: "调用系统相关接口自动采集",
          range:
            "设备识别码（IMEI，DUID，OUID，GUID，ICCID，MEID，Serial Number，IMSI，User ID，Android ID，Client ID）、设备信息（手机Region设置，设备型号，手机电量，手机操作系统版本及语言、网络配置信息）",
          link: "https://open.oppomobile.com/new/developmentDoc/info?id=10288",
        },
        {
          name: "VIVO推送 SDK",
          company: "维沃移动通信有限公司",
          goal: "消息推送",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识信息（如IMEI、EmmCID、UFSID、ANDROIDID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的Android ID）、使用推送服务的应用软件信息（如应用包名、版本号、APPID、安装、卸载、恢复出厂设置、运行状态）、设备制造商、网络相关信息（如IP地址、网络类型）、国家码、设备类型",
          link: "https://dev.vivo.com.cn/documentCenter/doc/652",
        },
        {
          name: "华为推送 SDK",
          company: "华为软件技术有限公司",
          goal: "消息推送",
          type: "调用系统相关接口自动采集",
          range:
            "应用信息（应用基本信息），设备信息（AAID、设备标识符、设备硬件信息、系统基本信息、系统设置）",
          link: "https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177",
        },
         {
          name: "增长营销套件 SDK",
          company: "北京火山引擎科技有限公司",
          goal: "保障软件与服务的安全运行以及优化产品体验，广告监测归因、广告投放统计分析、反作弊，减少App崩溃、提供稳定可靠的服务",
          type: "调用系统相关接口自动采集",
          range:
            "进程信息、设备品牌、型号、操作系统、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、浏览器的类型和版本号、操作、使用、服务日志，设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）、地理位置信息，网络访问，获取WiFi状态、设备应用安装列表信息，运营商信息、设备时区、sim卡信息",
          link: "https://www.volcengine.com/docs/6285/72216",
        },
        {
          name: "腾讯浏览服务SDK",
          company: "腾讯科技（深圳）有限公司",
          goal: "应用内H5页面访问",
          type: "调用系统相关接口自动采集",
          range:
            "设备信息,应用信息,Wi-Fi状态和参数,IP地址,AndroidID,CellID、OAID、BSSID、SSID",
          link: "https://rule.tencent.com/rule/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d",
        },
        {
          name: "MSA移动安全联盟SDK",
          company: "中国信息通信研究院",
          goal: "生成设备唯一标识符",
          type: "调用系统相关接口自动采集",
          range:
            "品牌信息，网络信息，应用软件信息",
          link: "https://www.msa-alliance.cn/col.jsp?id=122",
        },
         {
          name: "AGD Pro SDK",
          company: "华为软件技术有限公司",
          goal: "对API的调用情况进行必要的数据收集，用于统计分析及服务改进",
          type: "调用系统相关接口自动采集",
          range:
            "设备信息（设备品牌及型号、Android版本号、设备标识符（OAID）、通用唯一识别码（UDID）、 Android ID）、网络信息（网络连接状态、IP信息、Wi-Fi信息、运营商信息）、应用信息（应用包名）、接口信息（接口调用类型、SDK的版本号、接口调用结果码和错误码）、应用使用信息（您与本服务投放的广告之间的互动记录，如曝光、点击、推荐开关）",
          link: "https://developer.huawei.com/consumer/cn/doc/monetize/agd_pro_sdk_data-security-0000001192665648",
        },
        {
          name: "移动安全联盟 OAID",
          company: "中国信息通信研究院泰尔终端实验室、移动安全工作委员会",
          goal: "获取系统唯一标识码",
          type: "调用系统相关接口自动采集",
          range:
            "App包名及签名信息、设备制造商、设备型号、设备品牌、OAID、VAID、AAID",
          link: "https://www.msa-alliance.cn/col.jsp?id=122",
        },
         {
          name: "360加固SDK",
          company: "北京鸿享技术服务有限公司",
          goal: "用于检测App故障和诊断,App安全加固保护,盗版检测服务,威胁环境检测服务,以便帮助用户快速解决异常情况",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（Android ID、OAID）",
          link: "https://jiagu.360.cn/#/global/help/322",
        }
      ],
    };
  },
  methods: {
    go() {
      //直接跳转
      this.$router.push("/list");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
}

h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px;
}

li {
  margin: 10px 0;
  list-style: none;
}

p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
.red{
  color:red;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue